/**
 * text-layer.js — שכבת הכיתוב על הכרית.
 * ⚠️ קוד פיתוח בלבד. לא נוגע ב-Shopify ולא באתר החי.
 *
 * אחראית על: פריסת שורות, מדידה, ציור, ובדיקה אם המיקום חוקי.
 * לא יודעת כלום על ה-DOM ולא על המנוע — רק על קנבס.
 */
(function (global) {
  'use strict';

  const FONTS = [
    { id: 'Heebo',            label: 'הֵיבּוֹ',      group: 'נקי ומודרני', weight: 700 },
    { id: 'Assistant',        label: 'אסיסטנט',     group: 'נקי ומודרני', weight: 700 },
    { id: 'Rubik',            label: 'רוּבִּיק',      group: 'חם ועגול',    weight: 600 },
    { id: 'Varela Round',     label: 'ורלה עגול',   group: 'חם ועגול',    weight: 400 },
    { id: 'Secular One',      label: 'סֶקּוּלָר',      group: 'בולט',        weight: 400 },
    { id: 'Suez One',         label: 'סוּאֵץ',        group: 'בולט',        weight: 400 },
    { id: 'Frank Ruhl Libre', label: 'פְרַנְק רוּהְל',  group: 'אלגנטי',      weight: 700 },
    { id: 'Bellefair',        label: 'בֶּלְפֵייר',     group: 'אלגנטי',      weight: 400 },
  ];

  // תמיד נשאר משהו לצייר בו, גם אם Google Fonts לא נטען.
  const FALLBACK = "'Huninn','Arial Hebrew',Arial,sans-serif";

  const MAX_CHARS = 60;
  const MAX_LINES = 3;
  const WRAP_DEFAULT = 0.86;      // רוחב גלישה כשבר מהקנבס, כשלא נאמר אחרת

  function fontSpec(fontId, sizePx) {
    const f = FONTS.find((x) => x.id === fontId) || FONTS[0];
    return f.weight + ' ' + sizePx + 'px "' + f.id + '",' + FALLBACK;
  }

  /** חלוקה לשורות: קודם לפי Enter, ואז גלישה לפי רוחב מותר. */
  function layout(ctx, text, maxWidth) {
    const out = [];
    const hard = String(text).split('\n');
    for (const chunk of hard) {
      const words = chunk.split(/\s+/).filter(Boolean);
      if (!words.length) { continue; }
      let line = words[0];
      for (let i = 1; i < words.length; i++) {
        const test = line + ' ' + words[i];
        if (ctx.measureText(test).width <= maxWidth) line = test;
        else { out.push(line); line = words[i]; }
      }
      out.push(line);
      if (out.length >= MAX_LINES) break;
    }
    return out.slice(0, MAX_LINES);
  }

  /**
   * ציור הכיתוב.
   * כל המידות יחסיות ל-`size` כדי שאותה שכבה תיראה זהה בקנבס התצוגה
   * ובקנבס שנשלח למנוע, שהם ברזולוציות שונות.
   */
  function draw(ctx, size, state, opts) {
    const o = opts || {};
    if (!state.text.trim()) return null;

    const px = state.sizeRatio * size;
    ctx.save();
    ctx.font = fontSpec(state.font, px);
    ctx.direction = 'rtl';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // wrapW: רוחב הגלישה כשבר מרוחב הקנבס. ברירת מחדל 0.86 = כמו שהיה.
    // מוצר 2 מצמצם אותו כדי שהכיתוב ייכנס לסילואט צר (שתיים-שלוש שורות במקום אחת).
    const lines = layout(ctx, state.text, size * (state.wrapW != null ? state.wrapW : WRAP_DEFAULT));
    const lh = px * 1.24;
    const totalH = lines.length * lh;

    const cx = state.x * size;
    const cy = state.y * size;

    ctx.translate(cx, cy);
    // ═══ mirrorGlyphs — הכיתוב בגב (אלעד, 12.9) ═══
    // הגב הוא עותק של החזית שהגאומטריה מציגה במראה (כמו יריעה מקופלת).
    // כיתוב רגיל בעותק יוצא הפוך מאחור; שיקוף האותיות מראש, סביב מרכז
    // הכיתוב, מבטל את השיקוף של הגאומטריה — התמונה נשארת במראה, הכיתוב קריא.
    // השיקוף לפני ההטיה, כמו ב-pillow-text.js של מוצר 1: ההטיה נראית מאחור
    // באותו כיוון שהלקוח בחר. mask לא משתמש בזה — בדיקת האזור הבטוח היא על החזית.
    if (o.mirrorGlyphs) ctx.scale(-1, 1);
    if (state.rotation) ctx.rotate(state.rotation * Math.PI / 180);

    // צל עדין נותן קריאות מעל תמונה, בלי להיראות כמו אפקט.
    if (o.mask) {
      ctx.fillStyle = '#fff';
    } else {
      ctx.fillStyle = state.color;
      if (state.color.toLowerCase() === '#ffffff') {
        ctx.shadowColor = 'rgba(0,0,0,.30)';
        ctx.shadowBlur = px * 0.12;
        ctx.shadowOffsetY = px * 0.03;
      }
    }

    let y = -totalH / 2 + lh / 2;
    let widest = 0;
    for (const ln of lines) {
      widest = Math.max(widest, ctx.measureText(ln).width);
      ctx.fillText(ln, 0, y);
      y += lh;
    }
    ctx.restore();

    return { lines: lines.length, width: widest, height: totalH, cx, cy };
  }

  /**
   * מודד פריסה בלי לצייר: כמה שורות, הרוחב הגדול, והאם *כל* הטקסט נכנס.
   * complete=false פירושו ש-MAX_LINES חתך מילים — פריסה כזו אסור להציג ללקוח.
   */
  function measureLayout(size, state) {
    const c = document.createElement('canvas'); c.width = c.height = 8;
    const x = c.getContext('2d');
    const px = state.sizeRatio * size;
    x.font = fontSpec(state.font, px);
    const wrapW = state.wrapW != null ? state.wrapW : WRAP_DEFAULT;
    const lines = layout(x, state.text, size * wrapW);
    const norm = (t) => String(t).replace(/\s+/g, ' ').trim();
    let widest = 0;
    for (const ln of lines) widest = Math.max(widest, x.measureText(ln).width);
    return { lines: lines.length, width: widest / size, height: lines.length * px * 1.24 / size,
             complete: norm(lines.join(' ')) === norm(state.text) };
  }

  /** מסכת הכיתוב בלבד, ברשת של בדיקת האזור הבטוח. */
  function maskCanvas(G, state) {
    const c = document.createElement('canvas');
    c.width = c.height = G;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.clearRect(0, 0, G, G);
    draw(x, G, state, { mask: true });
    return c;
  }

  global.PZText = { FONTS, FALLBACK, MAX_CHARS, MAX_LINES, WRAP_DEFAULT, fontSpec, draw, maskCanvas, layout, measureLayout };
})(window);
